import React, { PropTypes } from 'react';
import classes from './index.scss';
import classnames from 'classnames';

const ValidationMessage = (props) => {

  const hasError = !!props.message && props.message.length;
  const validationClasses = classnames({
    "hasError": hasError,
    [classes["error-message"]]: true,
    [classes["empty"]]: !hasError,
  });

  return (
    <div className={ validationClasses }>
      { props.message }
    </div>
  )
}

ValidationMessage.propTypes = {
  message: PropTypes.string,
};

export default ValidationMessage;



/** WEBPACK FOOTER **
 ** ./shared-components/FormFields/ValidationMessage/index.js
 **/